import { CSSProperties } from 'react';
 
export const textFieldStyles: CSSProperties = {
	width: '100%',
	padding: '0.75rem',
	border: '1px solid #e2e8f0',
	borderRadius: '4px',
	fontSize: '1rem',
	transition: 'border-color 0.2s',
}
 
